// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.module.bid.data.bidround

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class Bid(
    @ReadWrite val username: String = "",
    @ReadWrite val amount: Double = 0.0
)

/**
 * Autogenerated Lens.
 * Read and manipulate [Bid.username]
 */
@ReadWrite val username: Lens<Bid, String> by lazy{ Lens(
    get = {whole -> whole.username},
    set = {part -> {whole -> whole.copy(username = part)}}
) }
/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Bid.username]
 */
@ReadWrite fun Bid.username(set: String.()->String ): Bid = copy(username = set(username)) 
/**
 * Autogenerated Lens.
 * Read and manipulate [Bid.amount]
 */
@ReadWrite val amount: Lens<Bid, Double> by lazy{ Lens(
    get = {whole -> whole.amount},
    set = {part -> {whole -> whole.copy(amount = part)}}
) }
/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Bid.amount]
 */
@ReadWrite fun Bid.amount(set: Double.()->Double ): Bid = copy(amount = set(amount)) 
